import { useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import { IUserAvatar } from '@interfaces/avatar';
import { getNotification } from '@components/Notification/helpers';
import { NOTIFICATION_TYPES, useNotification } from '@components/Notification';
import SelectAvatarItemView from './SelectAvatarItemView';
import { ISelectAvatarItemProps } from './interfaces';
import { useClientSpecificCustomTextDeleteEditActionsOnAvatar } from '@hooks/clientSpecificUtils';

const SelectAvatarItem = ({
  avatar,
  isSelectedAvatar,
  setSelectedAvatar,
  editAvatarClick,
  deleteAvatarClick,
  t: translate,
}: ISelectAvatarItemProps) => {
  const { showNotification } = useNotification();

  const { canEdit, canDelete, cannotEditAvatarNotification } =
    useClientSpecificCustomTextDeleteEditActionsOnAvatar(avatar);

  const editAvatarClickWithNotifications = useCallback(
    (avatar: IUserAvatar) => {
      if (canEdit) {
        editAvatarClick(avatar);
      } else {
        showNotification(
          getNotification({
            message: translate(`notifications.${cannotEditAvatarNotification}`),
            type: NOTIFICATION_TYPES.ERROR,
            withDismissButton: false,
            withReloadButton: false,
          }),
        );
      }
    },
    [editAvatarClick, canEdit, cannotEditAvatarNotification],
  );

  return (
    <SelectAvatarItemView
      avatar={avatar}
      editAvatarClick={editAvatarClickWithNotifications}
      deleteAvatarClick={deleteAvatarClick}
      isSelectedAvatar={isSelectedAvatar}
      setSelectedAvatar={setSelectedAvatar}
      canEdit={canEdit}
      canDelete={canDelete}
    />
  );
};

export default withTranslation()(SelectAvatarItem);
